import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";

export function useSchools() {
  const [schools,  setSchools]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    supabase
      .from("schools")
      .select("*")
      .order("id")
      .then(({ data, error }) => {
        if (error) setError(error.message);
        else setSchools(data ?? []);
        setLoading(false);
      });
  }, []);

  return { schools, setSchools, loading, error };
}
